import { Dispatch } from 'redux';
import { Action } from '../../store';
import { closePepperContext } from 'modules/cm/pages/CaseDetailsPage/Pepper/store/useCases/index';

const viewValFunc = () => {
  return async (dispatch: Dispatch<Action>, getState: any) => {
    await closePepperContext()(dispatch, getState);
  };
};

export default viewValFunc;
